import { useState, useEffect } from "react";
import { Route, Routes, Switch } from 'react-router-dom';
import JsonData from "./data/data.json";
import "./App.css";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import Home from "./pages/Home";
import { PageNotFound } from "./pages/pageNotFound";
import { Privacypolicy } from "./pages/privacypolicy";
import { Header } from "./components/header";
import "animate.css";
import { Footer } from "./components/footer";



const App = () => {

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
    <div className="call-support animate__animated animate__floatUpDown">

        <div className="call-icon">
          <a href="tel:18008917531">
          <img src="img/call-now3.png" alt="call support" />
          </a>
        </div>
      </div>
       <a
        href="https://wa.me/919310176089"
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn animate__animated animate__pulse animate__infinite"
      >
        <img src="img/whatsapp.png" alt="whatsapp" />
      </a>

      <Header />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
 
      </Routes>
      <Footer />
    </div>

  );
};


export default App;
